export default __webpack_public_path__ + "static/media/1699.853f62ba.png";